import { handleError } from '@/utils/exception_handler';

import api from './api';

export default {

  // Users FETCH mutations on COMMENTS
  fetchInvoices: (context, args) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'fetchInvoices';

    commit(`${mutationPrefix}Pending`);

    return api.fetchInvoices(args)
      .then((response) => {
        dispatch('insert', { data: response.entities });

        commit(`${mutationPrefix}Success`, response.entities);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses CREATE mutations on COMMENTS
  createInvoice: (context, data) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'createInvoice';

    commit(`${mutationPrefix}Pending`);

    return api.createInvoice(data)
      .then((response) => {
        dispatch('insert', { data: response.entity });

        commit(`${mutationPrefix}Success`);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses UPDATE mutations on COMMENTS
  updateInvoice: (context, requestParams) => {
    const { commit, dispatch } = context;
    const { id } = requestParams;
    const mutationPrefix = 'updateInvoice';

    commit(`${mutationPrefix}Pending`, id);

    return api.updateInvoice(requestParams)
      .then((response) => {
        dispatch('update', response.entity);

        commit(`${mutationPrefix}Success`, id);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`), { id })
      .catch(handleError(context, `${mutationPrefix}Error`, { id }));
  },

  // Uses DELETE mutations on COMMENTS
  deleteInvoice: (context, id) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'deleteInvoice';

    commit(`${mutationPrefix}Pending`, id);

    return api.deleteInvoice(id)
      .then((response) => {
        dispatch('delete', id);

        commit(`${mutationPrefix}Success`, response);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`, { id }))
      .catch(handleError(context, `${mutationPrefix}Error`, { id }));
  },

  setContext: ({ commit }, payload = null) => {
    commit('setContext', payload);
  },

  openFormModal: ({ commit }, payload) => {
    commit('openFormModal', payload);
  },

  closeFormModal: ({ commit }) => {
    commit('closeFormModal');
  },

};



// WEBPACK FOOTER //
// ./src/store/modules/invoice/actions.js